import config from 'config/common';
import {
    EMPTY_PHONE_NUMBER_PLACEHOLDER,
    INITIAL_SOCIAL_REGISTRATION_PHONE_NUMBER_MASK,
} from 'scenes/RegisterVerification/PhoneVerification/phone-verification.constants';
import { AccountInfoParsed } from 'services/generatedClientFromSwagger/models';

export const hasValidPhoneNumber = (phoneNumber: string | undefined | null): boolean =>
    Boolean(
        phoneNumber &&
            phoneNumber !== EMPTY_PHONE_NUMBER_PLACEHOLDER &&
            phoneNumber !== INITIAL_SOCIAL_REGISTRATION_PHONE_NUMBER_MASK
    );

export const checkUserDataComplete = (
    userInfo: AccountInfoParsed | undefined
): {
    isComplete: boolean;
    needsPhone: boolean;
    needsCountry: boolean;
} => {
    if (!userInfo) {
        return {
            isComplete: false,
            needsPhone: false,
            needsCountry: false,
        };
    }

    const registerFlags = config.registerFlags;
    const needsPhone =
        (registerFlags.phoneNumber || registerFlags.phoneCountryCode) && !hasValidPhoneNumber(userInfo.phoneNumber);
    const needsCountry = registerFlags.countryCode && !userInfo.country_short;

    return {
        isComplete: !needsPhone && !needsCountry,
        needsPhone,
        needsCountry,
    };
};
